import { SelectItem } from '@/models/select_item';

const selectItems: Array<SelectItem> = [];

selectItems.push(new SelectItem({
  name: 'ルビー（日常編）',
  key: 'voice01',
  backgroundImage: 'voice01.png',
  limitedMCC: false,
}));

selectItems.push(new SelectItem({
  name: 'ルビー（プレミアム編）',
  key: 'voice02',
  backgroundImage: 'voice02.png',
  limitedMCC: false,
}));

selectItems.push(new SelectItem({
  name: '有馬かな（日常編）',
  key: 'voice03',
  backgroundImage: 'voice03.png',
  limitedMCC: false,
}));

selectItems.push(new SelectItem({
  name: '有馬かな（プレミアム編）',
  key: 'voice04',
  backgroundImage: 'voice04.png',
  limitedMCC: false,
}));

selectItems.push(new SelectItem({
  name: 'MEMちょ（日常編）',
  key: 'voice05',
  backgroundImage: 'voice05.png',
  limitedMCC: false,
}));

selectItems.push(new SelectItem({
  name: 'MEMちょ（プレミアム編）',
  key: 'voice06',
  backgroundImage: 'voice06.png',
  limitedMCC: false,
}));

selectItems.push(new SelectItem({
  name: 'B小町（日常編）',
  key: 'voice07',
  backgroundImage: 'voice07.png',
  limitedMCC: false,
}));

selectItems.push(new SelectItem({
  name: 'B小町（プレミアム編）',
  key: 'voice08',
  backgroundImage: 'voice08.png',
  limitedMCC: false,
}));

selectItems.push(new SelectItem({
  name: 'アクア',
  key: 'voice09',
  backgroundImage: 'voice09.png',
  limitedMCC: true,
}));

selectItems.push(new SelectItem({
  name: '黒川あかね',
  key: 'voice10',
  backgroundImage: 'voice10.png',
  limitedMCC: true,
}));

export default selectItems;
